module.exports = "/Users/modetojoy/work/10gen/compass-server-version/lib/assets/images/fontawesome-webfont__jVM_i.eot";


//////////////////
// WEBPACK FOOTER
// ./node_modules/font-awesome/fonts/fontawesome-webfont.eot
// module id = 14
// module chunks = 0